import MidiEffect from '../MidiEffect.js';
import ParamMappable from './ParamMappable.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import {setEffectParameterValues} from 'actions/index.js';
import {EQ, LTE, GTE}from "constants/conditional-types.js";

class ConditionalParametersEffect extends ParamMappable(MidiEffect) {
    constructor(track) {
        super('Conditional Parameters', track);
        this.setupRampParameters();

        this.conditionalTypeParameter = new AbstractParameter(
            'conditionalType',
            this, () => [],
            {
                defaultValue: EQ
            });
        this.registerParameter(this.conditionalTypeParameter);

        this.conditionalValueParameter = new AbstractParameter(
            'conditionalValue',
            this, () => [],
            {
                defaultValue: 0
            });
        this.registerParameter(this.conditionalValueParameter);

        this.thenValueParameter = new AbstractParameter(
            'thenValue',
            this, () => [],
            {
                defaultValue: 0
            });
        this.registerParameter(this.thenValueParameter);

        // the 1st parameter is used as the "FROM PARAMETER"
        // i.e. the parameter we observe, and who's value we
        // condition on
        this.parametersDisabledParameter.set([0]);
    }

    /*
    get key() {
        return "conditionalMap";
    }
    */

    get conditionalType() {
        return this.conditionalTypeParameter.get(true);
    }

    get conditionalValue() {
        return this.conditionalValueParameter.get(true);
    }

    get thenValue() {
        return this.thenValueParameter.get(true);
    }

    get fromParameter() {
        return this._parameters[0];
    }

    getText() { return ""; }

    stop() {
        super.stop();
    }

    clear() {
        super.clear();
    }

    output(time, stepNumber) {
        if (!this.track.sequencerEngine.playing) {
            return this.triggers;
        }
        if (stepNumber === 0 && this.resetAtZero && this.counter !== 0) {
            this.stop();
            this._clear();
        }

        if (this.triggers.length === 0) {
            return this.triggers;
        }

        this.setParameterValues(time);
        return this.triggers;
    };

    getParameterValueToSet(i) {
        if (this.isConditionMet()) {
            return this.thenValue;
        }
        return this.initialParameterValues[i];
    }

    isConditionMet() {
        if (!this.fromParameter) {
            return false;
        }

        let fromValue = this.fromParameter.getNumber();
        switch (this.conditionalType) {
        case LTE:
            return fromValue <= this.conditionalValue;
        case GTE:
            return fromValue >= this.conditionalValue;
        default:
            return fromValue === this.conditionalValue;
        }
    }

    getCopy(track, ignoreId=true) {
        let effect = new ConditionalParametersEffect(track);
        effect.fromJson(this.getJson(), ignoreId);
        return effect;
    }

    shouldSkipParameter(i) {
        return parseInt(i) === 0;
    }
}

export default ConditionalParametersEffect;


